<template>
  <nuxt-link :to="localePath(to, lang)">
    <slot />
  </nuxt-link>
</template>

<script>
export default {
  props: {
    to: { type: [String, Object], required: true },
    lang: { type: String, default: '' },
  },
}
</script>
